export const RightArrow = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_6_2651'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='6'
      y='4'
      width='8'
      height='12'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.05806 4.55806C7.30214 4.31398 7.69786 4.31398 7.94194 4.55806L12.8712 9.48735C13.1544 9.77048 13.1544 10.2295 12.8712 10.5127L7.94194 15.4419C7.69786 15.686 7.30214 15.686 7.05806 15.4419C6.81398 15.1979 6.81398 14.8021 7.05806 14.5581L11.6161 10L7.05806 5.44194C6.81398 5.19786 6.81398 4.80214 7.05806 4.55806Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_6_2651)'>
      <rect width='20' height='20' fill='#808080' />
    </g>
  </svg>
)
